import { CircularProgress } from "@material-ui/core";
import { ColorV2 } from "config/colors";
import styled from "styled-components";
import { Logo } from "../salary/salary.styled";

export const SearchWrap = styled.div`
  width: calc(100% - 12px);
  margin-top: 22px;
`;

export const WorkerList = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-height: 520px;
  overflow-y: auto;
  padding-right: 8px;

  scrollbar-gutter: stable;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${ColorV2.Blue7};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${ColorV2.Blue6};
    border-radius: 8px;
  }
`;

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .checkbox-component {
    margin-top: 2px;
  }
`;

export const CheckboxWrap = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const LoaderWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 0;
`;

export const ActionWrap = styled.div`
  margin-top: 22px;
  display: flex;
  justify-content: center;
`;

export const SimflexityPayStyledLogo = styled(Logo)`
  height: 14px;
  width: auto;
  margin-left: -20px;
  margin-right: 30px;
  margin-top: 18px;
`;

export const StyledLoader = styled(CircularProgress)`
  width: 24px !important;
  height: 24px !important;
`;
